import React from "react";
import { makeStyles, Box, Typography } from "@material-ui/core";
import LoadingComponent from "components/loading";
import DashboardScanCountMap from "../../map/dashboardScanCountMap";

const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: "0px 4px 4px 0px rgb(0 0 0 / 10%)",
    backgroundColor: "white",
  },
  disabledMapContainer: {
    height: 350,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    color: "#666",
  },
}));

export default function ScanMapCardComponent({
  mapScans,
  isLoading,
  handleClusterClick,
  handleMarkerClick,
  revealProduct,
  updateRevealProductStatus,
  defaultGeoLocation,
  defaultZoom,
}) {
  const classes = useStyles();
  const isMapDisabled = process.env.REACT_APP_DISABLE_CONSUMER_SCAN_MAP === 'true';

  return (
    <Box classes={{ root: classes.card }}>
      {isLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height={350}
        >
          <LoadingComponent />
        </Box>
      ) : isMapDisabled ? (
        <Box className={classes.disabledMapContainer}>
          <Typography variant="h6">
            Consumer Scan Map is disabled
          </Typography>
        </Box>
      ) : (
        <Box>
          <DashboardScanCountMap
            mapScans={mapScans}
            handleClusterClick={handleClusterClick}
            handleMarkerClick={handleMarkerClick}
            revealProduct={revealProduct}
            updateRevealProductStatus={updateRevealProductStatus}
            defaultGeoLocation={defaultGeoLocation}
            defaultZoom={defaultZoom}
          />
        </Box>
      )}
    </Box>
  );
}
